import React from 'react';
import StyleguideSpecimen from './Styleguide-Specimen';
import LanguageSelector from '../pages/Header/LanguageSelector/LanguageSelector';

/**
 * Demonstrates the language selector component functionality.
 * Shows how the dropdown language switcher works with different languages.
 */
const StyleguideLanguageSelector = (props) => (
  <StyleguideSpecimen {...props} e2eId="styleguide-language-selector">
    <div
      style={{
        padding: '20px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
      }}
    >
      <h3>Language Selector Demo</h3>
      <p>This demonstrates the dropdown language selector component:</p>

      <div style={{ margin: '20px 0' }}>
        <h4>Current Header Language Selector:</h4>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '10px',
            backgroundColor: '#fff',
            borderRadius: '8px',
          }}
        >
          <LanguageSelector />
        </div>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h4>Features:</h4>
        <ul>
          <li>Dropdown design with current language display</li>
          <li>Click to open/close language options</li>
          <li>Automatic language detection from URL</li>
          <li>Support for EN and NL languages</li>
          <li>Responsive design for mobile and desktop</li>
          <li>Click outside to close functionality</li>
          <li>Accessibility support with ARIA attributes</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h4>Usage Instructions:</h4>
        <ol>
          <li>Click on the language selector button above</li>
          <li>Select a different language from the dropdown</li>
          <li>Notice the URL changes to reflect the selected language</li>
          <li>Click outside the dropdown to close it</li>
        </ol>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h4>URL Examples:</h4>
        <ul>
          <li>
            <code>/en/</code> - English version
          </li>
          <li>
            <code>/nl/</code> - Dutch version
          </li>
          <li>
            <code>/</code> - Default language (English)
          </li>
        </ul>
      </div>
    </div>
  </StyleguideSpecimen>
);

export default StyleguideLanguageSelector;
